import { IAdFoxBannerContext } from '@cian/adfox';
import * as React from 'react';

import { Container } from '../../../components/Container';
import {
  SIZE_100,
  SIZE_440,
  SIZE_WIDE,
} from '../../../constants/sizes';
import { Link } from '../../../components/Link';
import { Image } from '../../../components/Image';

export type TPIKBannerProps = {
  context: IAdFoxBannerContext,
  onMount?(): void;
};

export class PIKBanner extends React.Component<TPIKBannerProps, {}> {
  public componentDidMount() {
    if (this.props.onMount) {
      this.props.onMount();
    }
  }

  public render() {
    const {
      imageURL,
      alt,
      reference,
    } = this.props.context;

    return (
      <Container
        width={SIZE_440}
        maxWidth={SIZE_WIDE}
        height={SIZE_100}
      >
        <Link
          url={reference}
          target="blank"
          alt={alt}
        >
          <Image src={imageURL} />
        </Link>
      </Container>
    );
  }
}
